var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/ecf67698/0/pomelo/oceopin/web/app/themes/oceopin/node_modules/core-js/modules/_has.js
// module id = 12
// module chunks = 0